import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { initAppearance } from './lib/appearance.ts';
import './styles.css';

// Farbe und Hell/Dunkel vor dem ersten Rendern setzen, sonst blitzt kurz Rot auf.
initAppearance();

// Bewusst ohne StrictMode: das doppelte Mounten im Dev-Modus wuerde
// WebSocket- und PeerConnection-Aufbau zweimal ausloesen.
createRoot(document.getElementById('root')!).render(<App />);
